"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const employeeForm_1 = require("../validates/employeeForm");
const helpers_1 = require("core/helpers");
const formik_1 = require("formik");
const context_1 = require("src/context/context");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const Loading_1 = tslib_1.__importDefault(require("core/components/Loading"));
const PrimaryButton_1 = tslib_1.__importDefault(require("src/components/buttons/PrimaryButton"));
const react_1 = require("react");
const TaxRefielsAttributes_1 = tslib_1.__importDefault(require("./TaxRefielsAttributes"));
const useTaxReliefs_1 = tslib_1.__importDefault(require("../hooks/useTaxReliefs"));
const EmployeeTaxReliefs = (props) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const hook = (0, useTaxReliefs_1.default)({ id: props.id });
    const { toast } = (0, context_1.useToastContext)();
    const form = (0, formik_1.useFormik)({
        initialValues: hook.state.data,
        validateOnChange: false,
        enableReinitialize: true,
        validate: values => (0, employeeForm_1.EmployeeTaxValidations)(values, translate),
        onSubmit: async () => ({}) //passing async method for ts linter
    });
    (0, react_1.useEffect)(() => {
        props.setIsAnyError(form.errors);
    }, [form.errors]);
    return (hook.state.isFetching || hook.state.isOptionFetching
        ? (0, jsx_runtime_1.jsx)("div", { className: 'card-body', style: { height: 400 }, children: (0, jsx_runtime_1.jsx)(Loading_1.default, {}) })
        : (0, jsx_runtime_1.jsxs)("div", { className: 'card-body mb-10', children: [(0, jsx_runtime_1.jsx)(TaxRefielsAttributes_1.default, { taxReliefBenefit: form.values.taxReliefBenefit, useOfTaxRelief: form.values.useOfTaxRelief, taxReliefAmount: form.values.taxReliefAmount, setFieldValue: form.setFieldValue, taxOptions: form.values.taxOptions, errorTaxOptions: form.errors.errorTaxOptions, taxReliefAmountError: form.errors.taxReliefAmount, handleChange: form.handleChange, isLoading: hook.state.isLoading, taxReliefId: form.values.taxReliefId }), (0, jsx_runtime_1.jsx)("div", { className: 'text-right mt-10', children: (0, jsx_runtime_1.jsx)(PrimaryButton_1.default, { name: translate('button_save', 'შენახვა'), loading: hook.state.isUpdating, disabled: hook.state.isUpdating || !form.dirty, onClick: async () => {
                            const error = await form.validateForm();
                            if ((0, helpers_1.objectIsEmpty)(error)) {
                                const res = await hook.updateTaxValues(form.values, props.id);
                                res.errors === null
                                    ? toast.successMessage(res.status)
                                    : res.errors.map(el => toast.danger(el.message));
                            }
                        } }) })] }));
};
exports.default = EmployeeTaxReliefs;
